import React, { useState, useEffect } from 'react';
import config from '../config'; // Import the config.js file
import './ListMedia.css';
import SuccessModal from './modelpopup'; // Import SuccessModal component

const MediaList = () => {
  const [mediaList, setMediaList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [editingMedia, setEditingMedia] = useState(null);
  const [updatedMedia, setUpdatedMedia] = useState({});
  const [showSuccessModal, setShowSuccessModal] = useState(false); // State to control SuccessModal visibility
  const [modalMessage, setModalMessage] = useState(''); // Message to be displayed in the modal

  useEffect(() => {
    const fetchMedias = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(`${config.backendUrl}/api/images?category=All`);
        if (!response.ok) {
          throw new Error('Failed to fetch media');
        }
        const data = await response.json();
        console.log('Fetched media data:', data);
        setMediaList(data); // Set media list data
      } catch (error) {
        console.error('Error fetching media:', error);
        setError('There was an error fetching media. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchMedias();
  }, []);

  // Handle delete functionality
  const handleDeleteClick = async (id) => {
    console.log('Attempting to delete media with ID:', id);
    if (window.confirm('Are you sure you want to delete this media?')) {
      try {
        const response = await fetch(`${config.backendUrl}/api/delete_media/${id}`, {
          method: 'DELETE',
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.error || 'Failed to delete media');
        }

        setMediaList((prevList) => prevList.filter((media) => media.medias_id !== id));
        console.log(`Deleted media with ID: ${id}`);

        // Trigger success modal
        setModalMessage('Media deleted successfully!');
        setShowSuccessModal(true);
      } catch (error) {
        console.error('Error deleting media:', error.message);
      }
    }
  };

  // Handle edit functionality
  const handleEditClick = (media) => {
    setEditingMedia(media.medias_id);
    setUpdatedMedia({
      media_category: media.media_category,
      media_type: media.media_type,
      media_url: media.media_url,
    });
  };

  // Handle form input change for updated media data
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUpdatedMedia((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Handle save functionality
  const handleSaveClick = async (id) => {
    console.log('Attempting to save edited media with ID:', id);
    try {
      const response = await fetch(`${config.backendUrl}/api/update_media/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedMedia),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to update media');
      }

      setMediaList((prevList) =>
        prevList.map((media) =>
          media.medias_id === id ? { ...media, ...updatedMedia } : media
        )
      );

      setEditingMedia(null); // Exit edit mode
      console.log(`Updated media with ID: ${id}`);

      // Trigger success modal
      setModalMessage('Media updated successfully!');
      setShowSuccessModal(true);
    } catch (error) {
      console.error('Error saving media:', error.message);
    }
  };

  // Close the success modal
  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
  };

  return (
    <div className="media-list">
      {/* Render error or loading state */}
      {loading ? (
        <p>Loading media...</p>
      ) : error ? (
        <p style={{ color: 'red' }}>{error}</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Photo/Video</th>
              <th>Media Category</th>
              <th>Media Type</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {mediaList.length > 0 ? (
              mediaList.map((media, index) => (
                <tr key={media.medias_id}>
                  <td>{index + 1}</td>

                  {/* Display Photos */}
                  <td>
                    {media.media_type.toLowerCase().includes('photo') ||
                    media.media_type.startsWith('image') ? (
                      <img
                        src={media.media_url}
                        alt={`Media ${index}`}
                        style={{
                          width: '200px',
                          height: '150px',
                          borderRadius: '8px',
                          objectFit: 'cover',
                        }}
                      />
                    ) : media.media_type.toLowerCase().includes('video') ? (
                      <video
                        controls
                        style={{
                          width: '200px',
                          height: '150px',
                          borderRadius: '8px',
                          objectFit: 'cover',
                        }}
                      >
                        <source src={media.media_url} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    ) : null}
                  </td>

                  {/* Edit Mode or Normal Mode */}
                  {editingMedia === media.medias_id ? (
                    <td>
                      <select
                        name="media_category"
                        value={updatedMedia.media_category}
                        onChange={handleInputChange}
                      >
                        <option value="Free English Speaking Class Photos">Free English Speaking Class Photos</option>
                        <option value="ISRO Show">ISRO Show</option>
                        <option value="Free Cyber Security Session in Gov. School">Free Cyber Security Session in Gov. School</option>
                      </select>
                    </td>
                  ) : (
                    <td>{media.media_category}</td>
                  )}

                  {editingMedia === media.medias_id ? (
                    <td>
                      <select
                        name="media_type"
                        value={updatedMedia.media_type}
                        onChange={handleInputChange}
                      >
                        <option value="Photo">Photo</option>
                        <option value="Video">Video</option>
                      </select>
                    </td>
                  ) : (
                    <td>{media.media_type}</td>
                  )}

                  <td>
                    {editingMedia === media.medias_id ? (
                      <div>
                        <button
                          onClick={() => handleSaveClick(media.medias_id)}
                          style={{
                            marginRight: '10px',
                            padding: '5px 10px',
                            backgroundColor: 'green',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                          }}
                        >
                          Save
                        </button>
                        <button
                          onClick={() => setEditingMedia(null)} // Cancel edit mode
                          style={{
                            padding: '5px 10px',
                            backgroundColor: 'gray',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <button
                        onClick={() => handleEditClick(media)}
                        style={{
                          marginRight: '10px',
                          padding: '5px 10px',
                          backgroundColor: '#d4a762',
                          color: 'white',
                          border: 'none',
                          borderRadius: '5px',
                        }}
                      >
                        Edit
                      </button>
                    )}

                    <button
                      onClick={() => handleDeleteClick(media.medias_id)}
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'red',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">No media found</td>
              </tr>
            )}
          </tbody>
        </table>
      )}

      {/* Success Modal */}
      {showSuccessModal && (
        <SuccessModal message={modalMessage} onClose={handleCloseSuccessModal} />
      )}
    </div>
  );
};

export default MediaList;
